import { useState } from 'react';

import Snippet from '../../components/Snippet/Snippet'

const Background = () => {

    const [code, setCode] = useState('<div class="bg-dark"></div>')
    const [element, setElement] = useState(<div className="bg-dark h25 align-items-center justify-content-center">
        <p className="text md"> .bg-dark </p>
    </div>)

    const helper = p => {
        setCode(`<div class="${p}"></div>`)
        setElement(<div className={`${p} h25 align-items-center justify-content-center border-dark`}>
            <p className="text md"> .{p}</p>
        </div>)
    }

    return <div className="container fluid py-2" id="intro">

        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Backgrounds in POKE-CSS</p>
            <p className="text md secondary"></p>
        </div>

        <div className="spacer md"></div>

        <div className="container md">
            <button onClick={() => helper('bg-dark')} className="btn sm dark">click!</button>
            <button onClick={() => helper('bg-light')} className="btn sm light">click!</button>
            <button onClick={() => helper('bg-primary')} className="btn sm primary">click!</button>
            <button onClick={() => helper('bg-info')} className="btn sm info">click!</button>
            <button onClick={() => helper('bg-success')} className="btn sm success">click!</button>
            <button onClick={() => helper('bg-danger')} className="btn sm danger">click!</button>
            <button onClick={() => helper('bg-warning')} className="btn sm warning">click!</button>
            <button onClick={() => helper('bg-secondary')} className="btn sm secondary">click!</button>
        </div>

        <div className="spacer md"></div>

        <div className="row align-items-center">
            <div className="col md-III">

                <div className="container md">
                    <Snippet code={code} language='html' />
                </div>

            </div>
            <div className="col md-III">

                <div className="container sm">
                    {element}
                </div>

            </div>
        </div>
    </div>
}

export default Background